export interface ArticleSection {
  heading: string;
  paragraphs: string[];
}

export interface DeepArticle {
  id: string;
  title: string;
  category: string;
  author: string;
  date: string;
  readTime: string;
  cover: string;
  excerpt: string;
  tags: string[];
  sections: ArticleSection[];
}

export const deepArticles: DeepArticle[] = [
  {
    id: "kong-72h",
    title: "黑料网爆出圈是怎么发生的：拆解话题被传疯的 72 小时",
    category: "传播观察",
    author: "观察员 · 山楂",
    date: "2026-09-08",
    readTime: "8 分钟",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20editorial%20illustration%20of%20glowing%20crimson%20and%20amber%20data%20waves%20spreading%20outward%20across%20a%20dark%20warm%20canvas%2C%20no%20people%2C%20no%20text%2C%20minimal%20geometric%20composition%2C%20soft%20grain&width=1200&height=800&seq=article-72h-cover&orientation=landscape",
    excerpt:
      "一次黑料网爆出圈，从来不是某一刻的偶然。从原始素材流出，到被搬运、二创、冲上热搜，再到全网被传疯，中间存在几个可以被观察到的固定节点。",
    tags: ["出圈路径", "扩散节点", "热搜"],
    sections: [
      {
        heading: "第 0 到 6 小时：素材在私域里先跑一轮",
        paragraphs: [
          "绝大多数话题在被大众看到之前，都已经在小范围里流转过一轮。原始素材往往先出现在群聊、小社区或者半公开的账号里，此时的讨论量很小，但方向已经确定。",
          "这一阶段最重要的不是传播广度，而是素材的“可转述性”——能不能用一句话说完、能不能配上图。可转述性越高，后面的扩散就越快。",
        ],
      },
      {
        heading: "第 6 到 20 小时：搬运决定话题的走向",
        paragraphs: [
          "当第一批娱乐账号开始搬运时，配文成为关键变量。同样的画面，配一句疑问句和配一句结论句，引发的讨论方向完全不同。",
          "这也是话题最容易失真的一段。素材在传递过程中被不断简化，最终留下的往往是最抓眼球的片段，而不是最完整的信息。",
        ],
      },
      {
        heading: "第 20 到 40 小时：登上热搜，转发量开始指数增长",
        paragraphs: [
          "一旦进入热搜榜单，话题就从“圈内讨论”变成了“公共议题”。此时转发量的增长速度通常远高于讨论量的增长，很多人只转不看。",
          "我们观察到的规律是：进入热搜后的一小时，往往是整个话题生命周期里转发增速最快的一小时。",
        ],
      },
      {
        heading: "第 40 到 72 小时：被传疯，然后回落",
        paragraphs: [
          "话题到达峰值后，如果没有新的信息增量，热度会自然回落。回落的速度和之前的上升速度往往成正比——冲得越猛，落得越快。",
          "真正能维持长周期的话题，通常都不是单一素材，而是不断有新的角度被挖出来。",
        ],
      },
    ],
  },
  {
    id: "shares-truth",
    title: "转发量不等于真相：热搜扩散中的三个常见误区",
    category: "理性吃瓜",
    author: "观察员 · 白桃",
    date: "2026-09-05",
    readTime: "6 分钟",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20isometric%20illustration%20of%20many%20small%20paper%20fragments%20flying%20through%20a%20warm%20amber%20and%20crimson%20light%20beam%20on%20dark%20background%2C%20no%20people%2C%20no%20text%2C%20clean%20minimal%20editorial%20style&width=1200&height=800&seq=article-shares-cover&orientation=landscape",
    excerpt:
      "数字越大，看起来就越可信，这是吃瓜时最容易踩的坑。转发量、热度值、讨论条数，各自代表的东西完全不一样。",
    tags: ["转发量", "误区", "信息核实"],
    sections: [
      {
        heading: "误区一：把转发量当成支持率",
        paragraphs: [
          "转发量衡量的是一条内容被扩散的广度，不代表认同。很多转发带着质疑、调侃甚至反驳的语气，本质上仍是把一个话题推得更远。",
        ],
      },
      {
        heading: "误区二：把热度值当成事实强度",
        paragraphs: [
          "热度值是一个综合指标，它同时包含搜索、讨论、转发等多个维度。它反映的是“有多少人在谈论”，而不是“有多少证据”。",
          "我们建议把热度值理解成注意力指标，而不是结论指标。",
        ],
      },
      {
        heading: "误区三：把截图当成原始素材",
        paragraphs: [
          "截图是最容易被修改也最容易被误读的形式。缺少上下文的一句话、被裁掉首尾的一段对话，都可能让同一件事变成完全不同的样子。",
          "当我们整理话题扩散轨迹时，会尽量标注素材的层级：是首发、是搬运，还是已经被多次加工的版本。",
        ],
      },
    ],
  },
  {
    id: "five-nodes",
    title: "从 0 到沸：一个词条冲上热搜要经过哪 5 个节点",
    category: "扩散机制",
    author: "观察员 · 青柠",
    date: "2026-08-30",
    readTime: "7 分钟",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20editorial%20illustration%20of%20five%20glowing%20nodes%20connected%20by%20thin%20lines%20ascending%20in%20a%20dark%20crimson%20and%20amber%20gradient%2C%20no%20people%2C%20no%20text%2C%20minimal%20tech%20aesthetic&width=1200&height=800&seq=article-nodes-cover&orientation=landscape",
    excerpt:
      "把热搜当成一个黑箱，会觉得它来得很突然。但如果把时间轴拉长，会发现在冲榜之前，已经有好几个可以被观察到的信号。",
    tags: ["热搜", "节点", "数据"],
    sections: [
      {
        heading: "节点一：小圈层讨论量出现异常",
        paragraphs: [
          "话题在自己的原生圈层里先出现讨论量的异常增长，通常早于它被大众看见 6 到 12 小时。",
        ],
      },
      {
        heading: "节点二：搬运账号开始集中发布",
        paragraphs: [
          "当同一素材在短时间内被多个账号分别发布，说明它已经越过了最初的圈层边界。",
        ],
      },
      {
        heading: "节点三：出现第一批二创内容",
        paragraphs: [
          "二创是话题真正开始扩散的标志。图文、混剪、配音，任何一种都意味着用户不再只是转发者，而是参与者。",
        ],
      },
      {
        heading: "节点四：搜索量开始超过讨论量",
        paragraphs: [
          "当越来越多人先去搜索再来讨论，说明话题已经进入了大众认知阶段，此时距离冲榜通常只剩几个小时。",
        ],
      },
      {
        heading: "节点五：进入榜单并形成讨论惯性",
        paragraphs: [
          "进入榜单之后，话题会获得额外的曝光加成，形成一段自我强化的循环，直到新的信息或新的话题把它顶下去。",
        ],
      },
    ],
  },
  {
    id: "screenshot-era",
    title: "截图满天飞的年代，怎样区分一手的瓜与加工过的料",
    category: "理性吃瓜",
    author: "观察员 · 苦瓜",
    date: "2026-08-26",
    readTime: "5 分钟",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20editorial%20illustration%20of%20layered%20translucent%20rectangular%20panels%20stacked%20in%20warm%20amber%20and%20deep%20red%20tones%20on%20dark%20background%2C%20no%20people%2C%20no%20text%2C%20clean%20minimal%20style&width=1200&height=800&seq=article-screen-cover&orientation=landscape",
    excerpt:
      "同样是截图，信息密度可以相差十倍。学会看几个细节，就能大致判断一条素材被加工过多少次。",
    tags: ["截图", "辨别", "素材"],
    sections: [
      {
        heading: "先看边界，再看内容",
        paragraphs: [
          "被裁切过的截图往往在边缘留下不对称的留白或截断的文字。如果一条对话只剩中间两句，那么它被刻意剪裁的概率很高。",
        ],
      },
      {
        heading: "留意时间与顺序",
        paragraphs: [
          "真实对话有时间戳和上下文顺序。加工过的素材常常顺序混乱，或者刻意省略掉最关键的一两条回应。",
        ],
      },
      {
        heading: "区分陈述与转述",
        paragraphs: [
          "一手素材通常来自当事人或现场，转述素材则带着明显的概括语气。把两者混在一起传播，是话题失真的主要原因。",
        ],
      },
    ],
  },
  {
    id: "two-engines",
    title: "大屏曝光与短视频二创：话题被传疯的两台加速引擎",
    category: "扩散机制",
    author: "观察员 · 桂圆",
    date: "2026-08-20",
    readTime: "6 分钟",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20editorial%20illustration%20of%20two%20large%20glowing%20gears%20in%20crimson%20and%20amber%20tones%20on%20a%20dark%20minimal%20background%2C%20no%20people%2C%20no%20text%2C%20soft%20grain%20texture&width=1200&height=800&seq=article-engine-cover&orientation=landscape",
    excerpt:
      "为什么有的瓜只在文字里流传，有的瓜却能霸占所有人的时间线？差别通常来自两类内容的推力。",
    tags: ["大屏", "二创", "扩散"],
    sections: [
      {
        heading: "大屏曝光：把话题推到不看八卦的人面前",
        paragraphs: [
          "线下大屏、直播间的滚动信息，会让话题接触到原本不关注它的用户群体，这一步是“出圈”的关键。",
        ],
      },
      {
        heading: "短视频二创：把话题变成可以反复消费的内容",
        paragraphs: [
          "二创把一个事件变成了可重复观看、可配乐、可加字的内容形式。它延长了话题的生命周期，也放大了传播半径。",
        ],
      },
      {
        heading: "两台引擎同时启动时会发生什么",
        paragraphs: [
          "当大屏曝光与二创同时出现，话题往往会在一到两个小时内完成从“有人在说”到“全网都在说”的跳跃。",
        ],
      },
    ],
  },
  {
    id: "why-out-of-circle",
    title: "为什么有些话题能出圈，有些却止步于小圈子",
    category: "传播观察",
    author: "观察员 · 石榴",
    date: "2026-08-15",
    readTime: "5 分钟",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20editorial%20illustration%20of%20concentric%20expanding%20rings%20in%20amber%20and%20deep%20crimson%20on%20dark%20background%20with%20subtle%20particles%2C%20no%20people%2C%20no%20text%2C%20minimal%20composition&width=1200&height=800&seq=article-circle-cover&orientation=landscape",
    excerpt:
      "出圈不是运气，而是话题结构本身决定的。能否被圈外的人理解，往往在素材第一次被写下来的时候就已经注定了。",
    tags: ["出圈", "结构", "共情"],
    sections: [
      {
        heading: "能被一句话讲清楚的话题，更容易出圈",
        paragraphs: [
          "圈外用户没有耐心阅读背景。话题如果需要三段以上的前情铺垫才能理解，它的传播半径通常就止步于原生圈层。",
        ],
      },
      {
        heading: "有公共情绪的切口，扩散更快",
        paragraphs: [
          "能让圈外人代入自身经验的话题，更容易获得二次解读和自发扩散。这也是很多娱乐话题能跨越圈层的原因。",
        ],
      },
      {
        heading: "缺少新信息增量的话题会迅速降温",
        paragraphs: [
          "当所有人都已经知道了结论，传播动力就会消失。持续有衍生话题的话题，才能真正“被传疯”一整天。",
        ],
      },
    ],
  },
];

export const getArticleById = (id: string) => deepArticles.find((item) => item.id === id);